import React, { useState, useEffect } from "react";
import { Typography, Select } from "antd";
import i18n from "i18n";
import CustomModal from "components/CustomModal";

const { Paragraph } = Typography;

const DEFAULT_RANDOM_DISPLAY_COUNT = 2;

export const randomDisplayOptions = Array.from({ length: 9 }, (_, i) => ({
  label: i + 2,
  value: i + 2,
}));

interface RandomDisplaySettingModalProps {
  visible: boolean;
  closeModal: () => void;
  onSave: (randomDisplayCount: number) => void;
  currentRandomDisplayCount: number;
}

const RandomDisplaySettingModal: React.FC<RandomDisplaySettingModalProps> = ({
  visible,
  closeModal,
  onSave,
  currentRandomDisplayCount,
}) => {
  // currentRandomDisplayCountが不正な場合は2を使う
  const getValidCount = (val: number | undefined | null) =>
    typeof val === "number" && val >= 2 && val <= 10
      ? val
      : DEFAULT_RANDOM_DISPLAY_COUNT;

  const [localRandomDisplayCount, setLocalRandomDisplayCount] = useState(
    getValidCount(currentRandomDisplayCount)
  );

  useEffect(() => {
    if (visible) {
      setLocalRandomDisplayCount(getValidCount(currentRandomDisplayCount));
    }
  }, [visible, currentRandomDisplayCount]);

  const handleSave = () => {
    onSave(localRandomDisplayCount);
  };

  const handleCloseModal = () => {
    closeModal();
  };

  return (
    <CustomModal
      title={i18n.t("survey.randomDisplay")}
      okText={i18n.t("common.save")}
      visible={visible}
      closeModal={handleCloseModal}
      onOk={handleSave}
    >
      <Paragraph>{i18n.t("survey.randomSettingText1")}</Paragraph>
      <div style={{ marginBottom: "16px" }}>
        <label style={{ display: "block", marginBottom: "8px" }}>
          {i18n.t("survey.randomSettingText2")}
        </label>
        <Select
          value={localRandomDisplayCount}
          onChange={setLocalRandomDisplayCount}
          options={randomDisplayOptions}
          style={{ width: "70px" }}
        />
      </div>
      <Paragraph>{i18n.t("survey.randomSettingText3")}</Paragraph>
    </CustomModal>
  );
};

export default RandomDisplaySettingModal;
